module.exports = __webpack_public_path__ + "static/szydlowo-9bb5325099a0ec39b835681ad7ccbd6e.png";